import React, { useEffect, useRef } from "react"
import { css } from "emotion"
import getUserFromLocalStorage from "../util/getUserFromLocalStorage"
import * as SocketIOClient from "socket.io-client"
import { User } from "../types"
import Tooltip from "./Tooltip"

const POP_SOUND =
	"https://strawberryjam.nyc3.cdn.digitaloceanspaces.com/pop.mp3"

interface AvatarProps {
	user: User
	tooltip: string
	action: React.ReactNode
	onClick: () => void
}

function Avatar(props: AvatarProps) {
	return (
		<div>
			<Tooltip label={props.tooltip} position="fixed">
				<div
					onClick={props.onClick}
					className={css`
						position: fixed;
						display: flex;
						align-items: center;
						justify-content: center;
						width: 55px;
						height: 55px;
						background: rgba(42, 54, 50, 0.2);
						border-radius: 50%;
						cursor: pointer;
						opacity: 0;
						transition: opacity 400ms ease-in-out;

						&:hover {
							opacity: 1;
						}
					`}
				>
					{props.action}
				</div>
			</Tooltip>
			<img
				src={props.user.avatar}
				className={css`
					box-sizing: border-box;
					width: 55px;
					height: 55px;
					border-radius: 30px;
					margin-right: 10px;
					box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
					cursor: pointer;
				`}
			/>
		</div>
	)
}

export interface ConnectedUsersProps {
	socket: SocketIOClient.Socket
	connectedUsers: User[]
	onOpenUserSettings: () => void
}

export default function ConnectedUsers(props: ConnectedUsersProps) {
	let currentUser = getUserFromLocalStorage()
	let currentUserName = currentUser ? currentUser.name : null

	function handleWave(toName: string) {
		if (currentUserName) {
			props.socket.emit("sayhello", {
				to: toName,
				from: currentUserName,
			})
		}
	}

	let userCount = props.connectedUsers.length
	let prevUserCount = useRef(userCount)

	useEffect(() => {
		if (userCount !== prevUserCount.current) {
			let sound = new Audio(POP_SOUND)
			sound.volume = 0.2
			sound.play()
			prevUserCount.current = userCount
		}
	}, [userCount, prevUserCount])

	return (
		<div
			className={css`
				display: flex;
				width: 100%;
				align-items: center;
				justify-content: center;
			`}
		>
			{props.connectedUsers.map((user) => {
				let isCurrentUser = user.name === currentUserName

				if (isCurrentUser) {
					return (
						<Avatar
							user={user}
							tooltip="Open My Settings"
							action="⚙️"
							onClick={props.onOpenUserSettings}
						/>
					)
				} else {
					return (
						<Avatar
							user={user}
							tooltip={`Wave 👋 at ${user.name}`}
							action="👋"
							onClick={() => handleWave(user.name)}
						/>
					)
				}
			})}
		</div>
	)
}
